import { getParameterSecondaryIdentityLabel } from './helpers';
import type { CanonicalParameterFeatureIdentity } from './types';

interface ParameterSecondaryIdentityProps {
    parameter: { path: string; canonicalFeature?: CanonicalParameterFeatureIdentity | null | undefined };
}

const ParameterSecondaryIdentity = ({ parameter }: ParameterSecondaryIdentityProps) => {
    const secondaryLabel = getParameterSecondaryIdentityLabel(parameter);

    return secondaryLabel ? <div className="truncate text-xs text-zinc-500">{secondaryLabel}</div> : null;
};

export default ParameterSecondaryIdentity;
